// removed by extract-text-webpack-plugin
module.exports = {"wrap":"RBRw3rFD-mK60GPSIeynb","music-logo":"_1DS-hzCndPxh9kZuXgxGjl","music-desc":"_4bsrNbdtSWzyLZQE6a3hI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/style/Header.less
// module id = 217
// module chunks = 0